import { StoreAction, XmAction } from 'store/actions';
import { Catalog, ProductDetails } from './models';

export function productCatalogReducer(state: Catalog, action: XmAction<Catalog>): Catalog {
    switch (action.type) {
        case StoreAction.GET_CATALOG:
            return action.payload;
        default:
            return state;
    }
}

export function productReducer(state: ProductDetails[] = [], action: XmAction<ProductDetails>): ProductDetails[] {
    switch (action.type) {
        case StoreAction.GET_PRODUCT_DETAIL:
            //  Check matching productDetials with matching slug and Always replace existing ProductDetails with the one from API
            const newState: ProductDetails[] = state.filter((product: ProductDetails) => action.payload.slug !== product.slug);
            newState.push(action.payload);

            return newState;

        default:
            return state;
    }
}
